// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GIKeTwrYK91Bn5nOeAmR {
  width: 50vw;
  height: 100vh;
  position: fixed;
  top: 0%;
  left: 0%;
  transform: translateX(-50%);
  gap: 10px;
  z-index: 9001;
}
.GIKeTwrYK91Bn5nOeAmR .rSvjkSsFhNFaDvn45JbV {
  display: flex;
  width: 100%;
  max-height: 60vh;
  overflow: auto;
  padding: 1rem;
  background-color: rgba(241, 245, 249, 0.3019607843);
  border-radius: calc(0.5rem - 2px);
  border: solid 1px #e2e8f0;
}
.GIKeTwrYK91Bn5nOeAmR .hEqVpCFaVETMP4PYwwgj {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
}

.WWF5UvDVh08ljYKJ6IGW {
  display: none;
}

.h4Pdj_yxcLrLuObCnjYQ {
  width: 36px !important;
  height: 36px !important;
}

#Y0AMvdKq3StRNVz1wVnI:hover {
  background-color: #f7fafc;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Alerta/AlertaModal/AlertaModal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;EACA,iCAAA;EACA,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,sBAAA;EACA,uBAAA;AACF;;AACA;EACE,yBAAA;AAEF","sourcesContent":[".alert-modal {\r\n  width: 50vw;\r\n  height: 100vh;\r\n  position: fixed;\r\n  top: 0%;\r\n  left: 0%;\r\n  transform: translateX(-50%);\r\n  gap: 10px;\r\n  z-index: 9001;\r\n\r\n  .alert-modal-corpo {\r\n    display: flex;\r\n    width: 100%;\r\n    max-height: 60vh;\r\n    overflow: auto;\r\n    padding: 1rem;\r\n    background-color: #f1f5f94d;\r\n    border-radius: calc(0.5rem - 2px);\r\n    border: solid 1px #e2e8f0;\r\n  }\r\n\r\n  .alert-modal-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 24px;\r\n  }\r\n}\r\n.alert-modal-hidden {\r\n  display: none;\r\n}\r\n.icon {\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n}\r\n#fecharBotao:hover {\r\n  background-color: #f7fafc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
var _1 = `GIKeTwrYK91Bn5nOeAmR`;
export { _1 as "alert-modal" };
var _2 = `rSvjkSsFhNFaDvn45JbV`;
export { _2 as "alert-modal-corpo" };
var _3 = `hEqVpCFaVETMP4PYwwgj`;
export { _3 as "alert-modal-footer" };
var _4 = `WWF5UvDVh08ljYKJ6IGW`;
export { _4 as "alert-modal-hidden" };
export var icon = `h4Pdj_yxcLrLuObCnjYQ`;
export var fecharBotao = `Y0AMvdKq3StRNVz1wVnI`;
export default ___CSS_LOADER_EXPORT___;
